import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { EVENT_TYPE } from 'app/constants/EventsConstants';

const bwImageShape = ImmutablePropTypes.mapContains({
  isInformative: PropTypes.bool,
  altText: PropTypes.string,
  url: PropTypes.string.isRequired,
  attribution: ImmutablePropTypes.mapContains({
    licenceEnable: PropTypes.bool,
    sourceTitle: PropTypes.string,
    sourceUrl: PropTypes.string,
    sourceAuthor: PropTypes.string,
    authorUrl: PropTypes.string,
    ccLicenseVersion: PropTypes.string,
    ccLicenseUrl: PropTypes.string
  })
});

export default ImmutablePropTypes.mapContains({
  id: PropTypes.number.isRequired,
  contentType: ImmutablePropTypes.mapContains({
    label: PropTypes.string,
    slug: PropTypes.string
  }),
  title: ImmutablePropTypes.mapContains({
    text: PropTypes.string.isRequired
  }).isRequired,
  description: ImmutablePropTypes.mapContains({
    text: PropTypes.string
  }),
  url: PropTypes.string.isRequired,
  author: ImmutablePropTypes.mapContains({
    url: PropTypes.string,
    name: PropTypes.string.isRequired
  }),
  image: ImmutablePropTypes.mapContains({
    bwCardImage11: bwImageShape,
    bwCardImage21: bwImageShape
  }),
  event: ImmutablePropTypes.mapContains({
    type: PropTypes.oneOf([EVENT_TYPE.EVENT_BIBLIOEVENTS, EVENT_TYPE.EVENT_MANUAL]).isRequired,
    date: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string
  }),
  location: ImmutablePropTypes.mapContains({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
});
